﻿import { make } from '../utils';

const nodeTemplate = `
<template>
	<div class="title">
	  <i class="i-mdi-drag-variant"></i>
	  <div>
		<i class="i-mdi-question-mark-circle"></i>
		<i class="i-mdi-file-document-edit"></i>
	  </div>
	</div>

	<input df-name type="text" placeholder="Nome" autocomplete="off" />
	<input df-description type="hidden" placeholder="Descrizione" autocomplete="off" />
	<input df-customfield-id type="hidden" placeholder="Id Variabile" autocomplete="off" />
	<input df-customfield-type type="hidden" placeholder="Tipo Variabile" autocomplete="off" />
	<input df-documentdata type="hidden" placeholder="Dati Documento" autocomplete="off" />

	<div class="question-selection">
		<label>Domanda</label>
		<select df-question-type>
			<option value="0">No</option>
			<option value="1">Aperta</option>
			<option value="2">Variabile</option>
		</select>
		<button class="select-customfield-btn" type="button" disabled="disabled">
			<span>Scegli</span>
			<i class="i-mdi-cloud-search"></i>
		</button>
	</div>

	<div class="question-container">
		<textarea df-question-question type="text" placeholder="Domanda" autocomplete="off" rows="2"></textarea>
		<button class="add-answer-btn" type="button">
			<span>Aggiungi Risposta</span><i class="i-mdi-add-circle"></i>
		</button>
	</div>

	<div class="answers-container"></div>
</template>
`;

export const node = new DOMParser()
  .parseFromString(nodeTemplate, 'text/html')
  .querySelector('template');

export const getAnswerTemplate = function (index, answer, node) {

  let container = make('div', ['answer-container'], {});
  container.dataset.index = index;

  let removeBtn = make('button', ['remove-answer-btn'], {
	type: 'button',
	tabindex: '-1',
	innerText: 'x',
	removeAnswerBtn: ''
  });
  let valueInput = make('input', [], {
	type: 'text',
	name: 'value',
	value: `${answer.value}`,
	placeholder: `Chiave ${index}`,
	disabled: 'disabled'
  });
  let textInput = make('input', [], {
	type: 'text',
	name: 'text',
	value: `${answer.text}`,
	placeholder: `Risposta ${index}`,
  });
  let ruleSelect = make('select', [], {
	name: 'rule'
  });

  switch (node.data.customfield?.type) {
	case 0://Text
	case 1://Textarea
	  let compiled = make('option', [], {
		value: 'compiled',
		innerText: 'Compilata'
	  });
	  let notCompiled = make('option', [], {
		value: 'not-compiled',
		innerText: 'NON Compilata'
	  });
	  let contains = make('option', [], {
		value: 'contains',
		innerText: 'Contiene'
	  });
	  let notContains = make('option', [], {
		value: 'not-contains',
		innerText: 'Non Contiene'
	  })
	  switch (answer.rule) {
		case 'compiled':
		  compiled.setAttribute('selected', 'selected');
		  break;
		case 'not-compiled':
		  notCompiled.setAttribute('selected', 'selected');
		  break;
		case 'contains':
		  contains.setAttribute('selected', 'selected');
		  break;
		case 'not-contains':
		  notContains.setAttribute('selected', 'selected');
		  break;
		default:
		  compiled.setAttribute('selected', 'selected');
		  answer.rule = 'compiled';
		  break;
	  }
	  ruleSelect.appendChild(compiled);
	  ruleSelect.appendChild(notCompiled);
	  ruleSelect.appendChild(contains);
	  ruleSelect.appendChild(notContains);
	  break;
	case 3: //Choice
	  ruleSelect.appendChild(make('option', [], {
		value: 'eq',
		innerText: '=',
		selected: 'selected'
	  }));
	  answer.rule = 'eq';
	  break;
	case 2://Date
	case 4: //Number
	  let lt = make('option', [], {
		value: 'lt',
		innerText: '<'
	  });
	  let le = make('option', [], {
		value: 'le',
		innerText: '<='
	  });
	  let eq = make('option', [], {
		value: 'eq',
		innerText: '='
	  });
	  let ge = make('option', [], {
		value: 'ge',
		innerText: '>='
	  });
	  let gt = make('option', [], {
		value: 'gt',
		innerText: '>'
	  });
	  switch (answer.rule) {
		case 'lt':
		  lt.setAttribute('selected', 'selected');
		  break;
		case 'le':
		  le.setAttribute('selected', 'selected');
		  break;
		case 'eq':
		  eq.setAttribute('selected', 'selected');
		  break;
		case 'ge':
		  ge.setAttribute('selected', 'selected');
		  break;
		case 'gt':
		  gt.setAttribute('selected', 'selected');
		  break;
		default:
		  lt.setAttribute('selected', 'selected');
		  answer.rule = 'lt';
		  break;
	  }
	  ruleSelect.appendChild(lt);
	  ruleSelect.appendChild(le);
	  ruleSelect.appendChild(eq);
	  ruleSelect.appendChild(ge);
	  ruleSelect.appendChild(gt);
	  switch (node.data.customfield?.type) {
		case 2:
		  textInput.type = 'date';
		  break;
		case 4:
		  textInput.type = 'number';
		  break;
	  }
	  break;
	case 5: //Image
	  break;
	  ruleSelect.appendChild(make('option', [], {
		value: 'eq',
		innerText: '=',
		selected: 'selected'
	  }));
	  answer.rule = 'eq';
	  break;
	default:
	  ruleSelect.appendChild(make('option', [], {
		value: 'eq',
		innerText: '=',
		selected: 'selected'
	  }));
	  ruleSelect.setAttribute('disabled', 'disabled');
	  answer.rule = 'eq';
	  break;
  }

  container.appendChild(removeBtn);
  container.appendChild(valueInput);
  container.appendChild(ruleSelect);
  container.appendChild(textInput);
  return container.outerHTML;
}